import { createContext } from "react";

export const CustomThemeContext = createContext({
  primaryColor: undefined,
  setPrimaryColor: () => {},
});
